import React, { useState } from 'react';
import { IonButton, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCheckbox, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonImg, IonInput, IonItem, IonLabel, IonList, IonPage, IonRow, IonSegment, IonSegmentButton, IonText, IonTitle, IonToolbar } from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Home.css';
import { dataJSON } from '../data';
import { helpBuoyOutline, videocamOutline, bookOutline, helpOutline } from 'ionicons/icons';



const Home: React.FC = () => {

  const [email, setEmail] = useState();
  const [LoggedIn, setLoggedIn] = useState(false);
  const [name, setName] = useState();
  const [password, setPassword] = useState();
  const [password2, setPassword2] = useState();
  const [datenschutz, setDatenschutz] = useState();

  const [segment, setSegment] = useState('Login');

  function registerUser() {
    if (!email || !name || !password || !password2 || !datenschutz) {
      alert('Bitte alle Felder ausfüllen und die Datenschutzerklärung akzeptieren.');
      return;
    }
    return () => {
      console.log('login user:', { email, name, password, password2, datenschutz });

      alert('Registrierung erfolgreich! Bitte loggen Sie sich ein.');
      setLoggedIn(true);

    };
  }


  function loginUser() {
    if (!email || !name || !password) {
      alert('Bitte alle Felder ausfüllen und die Datenschutzerklärung akzeptieren.');
      return;
    }
    return () => {
      console.log('register user:', { email, name, password, password2, datenschutz });

      alert('Login erfolgreich! Willkommen zurück.');


    };
  }

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonTitle><IonImg src="logo_lichteMomente_mit_schrift.png" style={{ maxHeight: '5vh', height: "5vh" }} /></IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent fullscreen>
        <IonHeader collapse="condense">
          <IonToolbar>
            <IonTitle size="large"><IonImg src="logo_lichteMomente_mit_schrift.png" style={{ maxHeight: '10vh', height: "10vh" }} /></IonTitle>
          </IonToolbar>
        </IonHeader>
        <IonGrid>

          <IonRow>
            <IonCol sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
              <IonCard>
                <IonCardHeader>
                  <IonCardTitle>Herzlich Willkommen</IonCardTitle>
                  <IonCardSubtitle>im E-Learning-Kurs
                    für Angehörige von Menschen mit Demenz
                    und ehrenamtlich Engagierte!</IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent>
                  <p>
                    Ohne Angehörige und Ehrenamtliche, ohne Sie, läuft gar nichts in der Begleitung von Menschen mit Demenz. Fühlen Sie sich dabei verunsichert, alleingelassen, überfordert?<br /><br />
                    Die Begegnung mit Menschen mit Demenz wird für viele als unüberwindbare Hürde zum Verstehen und Kommunizieren empfunden.
                    Sie brauchen Unterstützung, verständliche Informationen, Kontaktmöglichkeiten?<br /><br />
                    Für Sie haben wir das E-Learning-Kurs „Lichte Momente“ entwickelt.</p>
                </IonCardContent>
              </IonCard>


              <IonCard>
                <IonCardHeader>
                  <IonCardTitle><IonImg src="logo_lichteMomente_mit_schrift.png" style={{ height: '3em' }} /></IonCardTitle>
                  <IonCardSubtitle>Ein E-Learning Kurs der Deutschen Stiftung für Demenzerkrankte</IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent>
                  <p>
                    <b>Ein Kurs, der Ihnen helfen will:</b>
                  </p>

                  <ul>
                    <li>Die Lebenswelt von Menschen mit Demenz kennenzulernen</li>
                    <li>Mit Hilfe von Fallbeispielen „typische“ Situationen in der Kommunikation zu erkennen</li>
                    <li>Tipps im Umgang mit kognitiven Beeinträchtigungen von Angehörigen zu erhalten</li>
                    <li>Interessante Informationen und Links über Demenz und engagierte Ansprechpartner zu finden</li>
                  </ul>
                  <b>weitere Informationen finden Sie auf unserer Webseite: <a href="https://lichtemomente.info">lichtemomente.info</a></b>

                </IonCardContent>
              </IonCard>
            </IonCol>
            <IonCol sizeLg='6' size="6" sizeSm='12' sizeXs='12'>
              <IonCard>
                <IonCardHeader>
                  <IonCardTitle>
                    Wie wäre es, wenn Sie sich in folgender Lage befänden?
                  </IonCardTitle>
                  <IonCardSubtitle></IonCardSubtitle>
                </IonCardHeader>
                <IonCardContent>
                  <p>
                    Ich wache auf und bin irgendwo. Ich kenne weder die Umgebung noch die Menschen, ich höre Stimmen, aber verstehe sie nicht. Jemand kommt mir näher und will mir einen Löffel in den Mund stecken. Was will die nur von mir? Ich fühle mich fremd, aber ich bin doch gesund ...<br /><br />
                    Vorübergehend nicht orientiert zu sein, diese Erfahrung gehört zum Leben, zur Lebenswelt, in der wir uns bewegen. Die Gegenwart erscheint uns wie ein Puzzle, bei dem wichtige Teile fehlen. Erinnerungen, Gedanken und aktuelle Ereignisse vermischen sich auf oft nicht nachvollziehbare Weise.<br /><br />

                    Plötzlich und unerwartet kommt Ihnen ein Gedanke oder ein Gefühl, die nach langem Grübeln eine dunkle Lage erhellen und ein Bild entsteht, das Sicherheit und Klarheit gibt. Wir verstehen und spüren wieder, wer wir und die anderen sind, wo wir uns bewegen, in welcher Tageszeit oder Jahreszeit wir leben.
                    <br />
                    <br /></p><IonButton routerLink='/Infos'>Informationen zum Kurs</IonButton>
                </IonCardContent>
              </IonCard>
              <IonCard>
                    <IonCardHeader>
                      <IonCardTitle>Registrieren Sie sich um Ihren Fortschritt zu verfolgen</IonCardTitle>
                    </IonCardHeader>
                    <IonCardContent>


                      <IonSegment value={segment} onIonChange={(e: any) => setSegment(e.detail.value!)}>
                        <IonSegmentButton value="Login">
                          <IonLabel>Login</IonLabel>
                        </IonSegmentButton>
                        <IonSegmentButton value="Register">
                          <IonLabel>Registrieren</IonLabel>
                        </IonSegmentButton>
                      </IonSegment>
                      {
                        segment === 'Register' ?
                          <>
                            <IonItem>
                              <IonInput onIonChange={(e: any) => { setEmail(e.detail.value!) }} value={email} label="E-Mail" type="email" ></IonInput>

                            </IonItem>
                            <IonItem>
                              <IonInput onIonChange={(e: any) => { setName(e.detail.value!) }} value={name} label="Name" type='text'></IonInput>
                            </IonItem>
                            <IonItem>
                              <IonInput onIonChange={(e: any) => { setPassword(e.detail.value!) }} value={password} label="Passwort" type='password'></IonInput>

                            </IonItem>
                            <IonItem>
                              <IonInput
                                onIonChange={(e: any) => { setPassword2(e.detail.value!) }}
                                value={password}
                                label="Passwort wiederholen" type='password'></IonInput>

                            </IonItem>
                            <IonItem>
                              <IonCheckbox onIonChange={(e: any) => { setDatenschutz(e.detail.value!) }}>Ich habe die Datenschutzerklärung gelesen.</IonCheckbox>
                            </IonItem>
                            <IonItem>
                              <IonButton onClick={() => registerUser()}>
                                registrieren
                              </IonButton>
                            </IonItem>

                          </>

                          :
                          <>
                            <IonItem>
                              <IonInput onIonChange={(e: any) => { setEmail(e.detail.value!) }} value={email} label="E-Mail" type="email" ></IonInput>

                            </IonItem>
                            <IonItem>
                              <IonInput onIonChange={(e: any) => { setPassword(e.detail.value!) }} value={password} label="Passwort" type='password'></IonInput>

                            </IonItem>
                            <IonButton onClick={() => loginUser()}>
                              Login
                            </IonButton>
                          </>
                      }


                    </IonCardContent>
                  </IonCard>
            </IonCol>

          </IonRow>
          <IonRow>


            <IonCol sizeLg='12' size="12" sizeSm='12' sizeXs='12'>
              <IonCard>
                <IonCardHeader>
                  <IonCardTitle>Die Module</IonCardTitle>
                </IonCardHeader>
                <IonCardContent>
                  <IonGrid>
                    <IonRow>
                      {
                        dataJSON.map((modul: any) => {
                          console.log(String(modul.Bild) + ".jpg")
                          return (
                            <IonCol sizeLg='6' size="12" sizeSm='12' sizeXs='12' key={Math.random()}>
                              <IonCard routerLink={'/ModulDyn/' + modul.Überschrift} style={{ height: '350px' }}>
                                <IonCardHeader>
                                  <IonCardTitle>{modul.Modul} - {modul.Überschrift}</IonCardTitle>
                                  <IonCardSubtitle>{modul.Unterüberschrift}</IonCardSubtitle>

                                </IonCardHeader>
                                <IonCardContent>
                                  <IonImg style={{ maxHeight: '250px' }}
                                    src={"/Modulbilder/" + String(modul.Modul) + ".jpg"}
                                  //src="05-gaymann-demensch-2023-03-300x234.jpg"
                                  //src="5-gaymann-demensch-2023-03-300x234.jpg"
                                  />
                                </IonCardContent>
                              </IonCard>
                            </IonCol>



                          )
                        })
                      }
                      <IonCol sizeLg='6' size="12" sizeSm='12' sizeXs='12' key={Math.random()}>
                        <IonCard routerLink={'/Modul/'} style={{ height: '350px' }}>
                          <IonCardHeader>
                            <IonCardTitle>Abschlussquiz</IonCardTitle>
                            <IonCardSubtitle></IonCardSubtitle>

                          </IonCardHeader>
                          <IonCardContent>
                            <IonIcon color="success" icon={helpOutline} style={{ fontSize: '300px' }} />
                          </IonCardContent>
                        </IonCard>
                      </IonCol>

                    </IonRow>
                  </IonGrid>


                </IonCardContent>
              </IonCard>
            </IonCol>

            

          </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default Home;
